import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { FOOTER_HEIGHT } from '../SideNavigation.constants.js';

var _templateObject;
var MenuList = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-bottom: ", ";\n  overflow-y: ", ";\n  position: relative;\n  flex: 1;\n  background: ", ";\n"])), FOOTER_HEIGHT, function (_ref) {
  var $hasOverflow = _ref.$hasOverflow;
  return $hasOverflow ? 'auto' : 'hidden';
}, function (_ref2) {
  var theme = _ref2.theme,
    $isSubMenuOpen = _ref2.$isSubMenuOpen;
  return $isSubMenuOpen ? theme.colours.navigation.secondary.main : theme.colours.navigation.primary.main;
});

export { MenuList, MenuList as default };
//# sourceMappingURL=SideNavigationMenuList.styles.js.map
